import './components/timers.js';
import './components/forms.js';

function openPrimaryMenu() {
    document.querySelector('.main-header-main-navigation').classList.toggle('main-header-main-navigation-toggle')
}

function closePrimaryMenu(el) {
    document.querySelector('.main-header-main-navigation').classList.remove('main-header-main-navigation-toggle')
}

if (document.querySelector('.main-header-main-navigation') && document.querySelector('.main-header-navigation-toggle')) {
    document.querySelector('.main-header-navigation-toggle').addEventListener("click", openPrimaryMenu)
    document.querySelector('.main-header-main-navigation-close').addEventListener("click", closePrimaryMenu)
}

//forms
if (document.querySelector('[name="hc"]')) {
    document.querySelector('[name="hc"]').value = 'I AM HUMAN';
}

document.querySelectorAll('.infusionsoft-form-slide input').forEach(function (input) {
    input.required = true;
});
document.querySelectorAll('.infusion-soft-form form input').forEach(function (input) {
    input.required = true;
});

document.querySelectorAll('[animate-scroll]').forEach(function (element) {
    element.addEventListener('click', function (e) {
        e.preventDefault();
        let href = element.getAttribute('href');
        let target = document.querySelector(href);
        window.scrollTo({
            top: target.offsetTop - 25,
            behavior: 'smooth'
        });
    });
});
